<template>
    <v-dialog
    v-model="localDialog"
    width="45%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Bank Account" : "Update Bank Account" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="BankSetup">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field
                            label="Account Title"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="account_title.value.value"
                            :error-messages="account_title.errorMessage.value"
                            clearable
                            auto-grow
                            rows="2"
                            >
                                <template #label>
                                    Account Title <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-text-field
                            label="Account No"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            type="text"
                            v-model="account_no.value.value"
                            :error-messages="account_no.errorMessage.value"
                            clearable
                            auto-grow
                            rows="2"
                            >
                                <template #label>
                                    Account No <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>

                            <v-text-field
                            label="Routing Number"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            type="text"
                            v-model.number="routing_number.value.value"
                            :error-messages="routing_number.errorMessage.value"
                            clearable
                            auto-grow
                            rows="2"
                            ></v-text-field>

                            <v-text-field
                            label="Swift Code"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model.number="swift_code.value.value"
                            :error-messages="swift_code.errorMessage.value"
                            clearable
                            auto-grow
                            rows="2"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-autocomplete
                            label="Account Head"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="bank_account_head_id.value.value"
                            clearable
                            :items="getPaymentAccountHeadList"
                            :error-messages="bank_account_head_id.errorMessage.value"
                            :item-title="item => `${item.name}`"   
                            autocomplete="off"
                            item-value="id"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Bank Account Head <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete>

                            <v-autocomplete
                            label="Bank"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="bank_id.value.value"
                            clearable
                            :items="getBankList"
                            :error-messages="bank_id.errorMessage.value"
                            :item-title="item => `${item.name}`"   
                            autocomplete="off"
                            item-value="id"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Bank <span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete>

                            <v-autocomplete
                            label="Bank Branch"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="bank_branch_id.value.value"
                            clearable
                            :items="getBankBranchList"
                            :error-messages="bank_branch_id.errorMessage.value"
                            :item-title="item => `${item.name}`"   
                            autocomplete="off"
                            item-value="id"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Bank Branch<span class="text-red-accent-4">*</span>
                                </template>
                            </v-autocomplete>

                            <v-textarea
                            label="Remarks (Optional)"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            type="number"
                            v-model.number="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            clearable
                            auto-grow
                            rows="2"
                            ></v-textarea>
                        </v-col>

                        <v-checkbox
                            label="Status"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            true-value="1"
                            false-value="0"
                        ></v-checkbox>
                    </v-row>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >
                                Close
                            </v-btn>

                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";

export default {
    name: "BankSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },

        data: {
            type: Object,
            default: () => ({
                bank_id: null,
                bank_branch_id: null,
                account_no: "",
                account_title: "",
                routing_number: null,
                swift_code: null,
                bank_account_head_id: null,
                status: "1",
                remarks: "",
            }),
        },
    },

    data() {
        return {
            localDialog: this.dialog,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },

    computed: {
        getPaymentAccountHeadList() {
            return this.$store.getters.getPaymentAccountHeadList;
        },
        getBankList() {
            return this.$store.getters.getBankList;
        },
        getBankBranchList() {
            return this.$store.getters.getBankBranchList;
        },
    },

    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.branch_id.setValue(newData.id || null, false);
                this.bank_account_head_id.setValue(newData.bank_account_head_id || null, false);
                this.bank_branch_id.setValue(newData.bank_branch_id || null, false);
                this.bank_id.setValue(newData.bank_id || null, false);
                this.account_no.setValue(newData.account_no || null, false);
                this.account_title.setValue(newData.account_title || null, false);
                this.swift_code.setValue(newData.swift_code || null, false);
                this.routing_number.setValue(newData.routing_number || null, false);
                this.remarks.setValue(newData.remarks || null, false);
                this.status.setValue(String(newData.status) || "1", false);
            },
        },
    },

    created() {
        // if (this.$store.getters.getPaymentAccountHeadList.length === 0) {
            this.$store.dispatch("getPaymentAccountHeadList", { type: "bank" });
        // }
        // if (this.$store.getters.getBankList.length === 0) {
            this.$store.dispatch("getBankList");
        // }
        // if (this.$store.getters.getBankBranchList.length === 0) {
            this.$store.dispatch("getBankBranchList");
        // }
    },
    
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },

    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                account_no: yup.string().required().label("Account No"),
                account_title: yup.string().required().label().label('Account Title'),
                bank_account_head_id: yup.number().required().label("Account Head"),
                bank_id: yup.number().required().label("Bank"),
                bank_branch_id: yup.number().required().label("Bank Branch"),   
            }),
        });

        const branch_id = useField("branch_id");
        const bank_account_head_id = useField("bank_account_head_id");
        const bank_id = useField("bank_id");
        const bank_branch_id = useField("bank_branch_id");
        const account_no = useField("account_no");
        const account_title = useField("account_title");
        const routing_number = useField("routing_number");
        const swift_code = useField("swift_code");
        const status = useField("status");
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();

        const submit = handleSubmit((values) => {
            let action;
            if(values.branch_id){
                action = "updateBankAccount";
            } else {
                action = "saveBankAccount";
            }

            store
            .dispatch(action, values)
            .then((response) => {
                resetForm();
                emit("update:dialog", false);
                toast.success(response.data.message);
                loading.value = true;
                store
                .dispatch("getBankAccountList")
                .then((data) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error.response.data.message);
                });
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });

        return {
            submit,
            branch_id,
            bank_account_head_id,
            bank_branch_id,
            bank_id,
            account_no,
            account_title,
            routing_number,
            swift_code,
            status,
            remarks,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {},
};
</script>
